// extracted by mini-css-extract-plugin
module.exports = {"label":"Kyc_label__61fmN","button":"Kyc_button___uBaP","headline":"Kyc_headline__vO8aQ","loader":"Kyc_loader__O20t8"};